// extracted by mini-css-extract-plugin
module.exports = {"scanningTestForm":"ScanningTest_scanningTestForm__1hbpr","scanningTestFormCard":"ScanningTest_scanningTestFormCard__TpVEv"};